import React from 'react'
import { Field } from 'redux-form'
import { Dropdown } from 'semantic-ui-react'
import cx from 'classnames'
import map from 'lodash/map'

import { ComponentContainer } from '../../StyledComponents'
import { getValidationClasses } from 'loankeeper-common/helpers'
import { formatOptions, dependentSelectsCustonOnChange } from '../helpers'

class SelectField extends React.PureComponent {
  static defaultProps = {
    flags: {},
  }

  handleInputChange = (e, { value }) => {
    const {
      input,
      flags,
      meta: { dispatch },
      customOnChange,
    } = this.props

    input.onChange(value)
    input.onBlur(value)

    if (flags.modifies) {
      dependentSelectsCustonOnChange(value, dispatch, flags)
    }

    if (customOnChange) customOnChange(value)
  }

  render() {
    const {
      input,
      className,
      allowAdditions,
      handleAddition,
      additionLabel,
      upward,
      options,
      disabled,
      required,
      meta: { error, touched, active },
      floatLeft,
      menuWidth,
      autoFocus,
      openOnFocus = false,
      selectOnBlur,
      maxLength,
      translateOptions,
      defaultFirst,
    } = this.props
    let value = input.value

    const propsOptions = map(options, ({ Title }) => ({ ID: Title, Title }))

    if (defaultFirst && options?.length) {
      value = options[0].ID
    }

    return (
      <ComponentContainer dropdown floatLeft={floatLeft} menuWidth={menuWidth} active={active}>
        <Dropdown
          {...input}
          className={cx(className, getValidationClasses(error, required, touched))}
          disabled={disabled}
          options={formatOptions(translateOptions ? propsOptions : options)}
          selection
          upward={upward}
          fluid
          autoFocus={autoFocus}
          onBlur={this.handleInputChange}
          onChange={this.handleInputChange}
          allowAdditions={allowAdditions}
          onAddItem={handleAddition}
          additionLabel={additionLabel}
          search
          searchInput={{ maxLength }}
          noResultsMessage=""
          openOnFocus={openOnFocus}
          selectOnBlur={selectOnBlur}
          value={Number.isNaN(parseFloat(value)) ? value : parseFloat(value)}
        />
      </ComponentContainer>
    )
  }
}

const DecoratedField = (props) => <Field {...props} component={SelectField} />

export default DecoratedField
